type Listener = (value: boolean) => void;

const offlineModeChannel = new BroadcastChannel("offline-mode-channel");

const offlineStore = {
  value: false,
  listeners: new Set<Listener>(),
  initialized: false,

  init() {
    if (this.initialized) return;
    this.initialized = true;

    offlineModeChannel.onmessage = (event) => {
      if (event.data?.type === "OFFLINE_MODE_UPDATED") {
        this.value = event.data.value;

        this.listeners.forEach((callback) => {
          callback(this.value);
        });
      }
    };

    offlineModeChannel.postMessage({ type: "GET_OFFLINE_MODE" });
  },

  set(value: boolean, url: string | null): Promise<void> {
    return new Promise((resolve) => {
      const handler = (event: MessageEvent) => {
        if (event.data?.type === "OFFLINE_MODE_UPDATED") {
          offlineModeChannel.removeEventListener("message", handler);
          const newUrl = url ? new URL(url) : new URL(window.location.href);
          window.location.href = `${newUrl.origin}${newUrl.pathname}`;
          resolve();
        }
      };

      offlineModeChannel.addEventListener("message", handler);

      offlineModeChannel.postMessage({
        type: "SET_OFFLINE_MODE",
        value,
      });
    });
  },

  subscribe(callback: Listener): () => void {
    this.listeners.add(callback);
    callback(this.value);

    return () => {
      this.listeners.delete(callback);
    };
  },
};

export default offlineStore;
